import { ref, onValue } from 'firebase/database';
import { database } from '../config/firebase';
import { listenToUserDocuments } from './documentService';

export interface PlanGateCounts {
  designCount: number;
  teamCount: number;
}

export const MAX_FREE_COUNT = 3;

// Get counts needed for gating in parallel. Returns an unsubscribe function.
export function subscribePlanCounts(
  userId: string,
  callback: (counts: PlanGateCounts) => void
) {
  let latest: PlanGateCounts = { designCount: 0, teamCount: 0 };

  const emit = () => callback({ ...latest });

  const unsubDocs = listenToUserDocuments(userId, (docs) => {
    latest.designCount = docs.length;
    emit();
  });

  const teamsRef = ref(database, 'teams');
  const unsubTeams = onValue(teamsRef, (snapshot) => {
    const data = snapshot.val();
    if (!data) {
      latest.teamCount = 0;
    } else {
      latest.teamCount = Object.values<any>(data).filter(
        (t: any) => t.members && t.members[userId]
      ).length;
    }
    emit();
  });

  return () => {
    if (typeof unsubDocs === 'function') unsubDocs();
    if (typeof unsubTeams === 'function') (unsubTeams as any)();
  };
}

export function canCreateDesign(designCount: number): boolean {
  return designCount < MAX_FREE_COUNT;
}

export function canCreateOrJoinTeam(teamCount: number): boolean {
  return teamCount < MAX_FREE_COUNT;
}

export type UserPlan = 'free' | 'pro' | 'enterprise';

// Subscribe to a lightweight plan flag under RTDB: users/{uid}/plan
export function subscribeUserPlan(
  userId: string,
  callback: (plan: UserPlan) => void
) {
  const planRef = ref(database, `users/${userId}/plan`);
  const unsub = onValue(planRef, (snap) => {
    const val = snap.val();
    const plan: UserPlan = val === 'pro' || val === 'enterprise' ? val : 'free';
    callback(plan);
  });
  return () => { if (typeof unsub === 'function') (unsub as any)(); };
}

export function isPro(plan: UserPlan | undefined): boolean {
  return plan === 'pro' || plan === 'enterprise';
}


